import { withGuidedHouseholdReviewLayoutWithStepper } from 'Components/UI/guidedHouseholdReview/layoutWrapperWithStepper';
import { Content } from './Content';

export default withGuidedHouseholdReviewLayoutWithStepper(Content);
